import React from 'react';
import './CourierComingSoon.css';

function CourierComingSoon() {
  return (
    <section className="courier-coming-soon-page">
      <div className="coming-soon-container">
        <h1>Coming Soon!</h1>
        <p>
          Our Courier Services are currently under development. 
          <br />
          Both <strong>Book your shipment</strong> and <strong>Track your shipment</strong> features will be available soon.
        </p>
      </div>
    </section>
  );
}

export default CourierComingSoon;
